<template>
  <v-dialog v-model="open" max-width="500px" persistent class="card-z">
    <!--
    <v-btn
      slot="activator"
      color="red lighten-2"
      dark
    >
      Click Me
    </v-btn>

    <component
      :is="item.component"
    ></component>
    -->

    <v-card v-if="item">
      <v-toolbar dense flat>
        <b>{{ item.title }}</b>
      </v-toolbar>

      <v-card-text>
        {{ item.subtitle }}
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-for="(action, index) in item.actions"
          :key="index"
          :color="action.color ? action.color : 'primary'"
          depressed
          @click="setValue(action)"
        >
          {{ action.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
//
import { SET_MODAL_VALUE } from '@/config/constants';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState('navigation', {
      open: state => state.modal.open,
      item: state => state.modal.item
    })
  },
  methods: {
    setValue(value) {
      this.$store.commit(SET_MODAL_VALUE, value);
    }
  }
};
</script>
<style scoped>
.card-z {
  z-index: 99999;
}
</style>
